import React from "react";

const MvPersonal = () => {
  return <div>MvPersonal</div>;
};

export default MvPersonal;
